// extracted by css-extract-rspack-plugin
export default {"root":"D3ipfZ","logo":"H1vkZc"};